import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { InkindSearch, PageSection } from '@gik/ui';

export default function NotFoundPage(): React.ReactElement {
  const bem = bemBlock('not-found-page');
  const { t } = useTranslation();
  return (
    <PageSection className={bem()}>
      <hgroup>
        <h1>{t(translationKeys.title)}</h1>
        <h2>{t(translationKeys.subTitle)}</h2>
      </hgroup>
      <p>{t(translationKeys.description)}</p>
      <br />
      <InkindSearch placeholder={t(translationKeys.searchPlaceholder)} />
    </PageSection>
  );
}
